import Question from "../../entities/question";

/**
 * Question actions
 *
 * Call order:
 *
 * QUESTION_SAVE_QUEUE:	adds the item to the save queue
 * --> QUESTION_SAVE:	modifies the state
 * --> QUESTION_SAVE_SUCCESS: if all went well
 * --> QUESTION_SAVE_FAILURE:	if either the queue or local save failed
 *
 * Note that the only way to fail QUESTION_SAVE_QUEUE is during the call to QUESTION_SAVE,
 * as adding an item to the queue should never fail.
 */

export const QUESTION_FETCH_ONE_QUEUE: any = 'QUESTION_FETCH_ONE_QUEUE';
export const QUESTION_FETCH_SUCCESS: any = 'QUESTION_FETCH_SUCCESS';
export const QUESTION_FETCH_FAILURE: any = 'QUESTION_FETCH_FAILURE';
export const QUESTION_FETCH_ONE_SUCCESS: any = 'QUESTION_FETCH_ONE_SUCCESS';
export const QUESTION_FETCH_ONE_FAILURE: any = 'QUESTION_FETCH_ONE_FAILURE';

export const QUESTION_SAVE: any = 'QUESTION_SAVE';
export const QUESTION_SAVE_QUEUE: any = 'QUESTION_SAVE_QUEUE';
export const QUESTION_SAVE_SUCCESS: any = 'QUESTION_SAVE_SUCCESS';
export const QUESTION_SAVE_FAILURE: any = 'QUESTION_SAVE_FAILURE';

export const QUESTION_SAVE_MANY: any = 'QUESTION_SAVE_MANY';
export const QUESTION_SAVE_MANY_QUEUE: any = 'QUESTION_SAVE_MANY_QUEUE';
export const QUESTION_SAVE_MANY_SUCCESS: any = 'QUESTION_SAVE_MANY_SUCCESS';
export const QUESTION_SAVE_MANY_FAILURE: any = 'QUESTION_SAVE_MANY_FAILURE';

export const QUESTION_REMOVE: any = 'QUESTION_REMOVE';
export const QUESTION_REMOVE_QUEUE: any = 'QUESTION_REMOVE_QUEUE';
export const QUESTION_REMOVE_SUCCESS: any = 'QUESTION_REMOVE_SUCCESS';
export const QUESTION_REMOVE_FAILURE: any = 'QUESTION_REMOVE_FAILURE';

export const QUESTION_RESTORE: any = 'QUESTION_RESTORE';
export const QUESTION_RESTORE_QUEUE: any = 'QUESTION_RESTORE_QUEUE';
export const QUESTION_RESTORE_SUCCESS: any = 'QUESTION_RESTORE_SUCCESS';
export const QUESTION_RESTORE_FAILURE: any = 'QUESTION_RESTORE_FAILURE';

export const QUESTION_RESTORE_MANY: any = 'QUESTION_RESTORE_MANY';
export const QUESTION_REMOVE_MANY: any = 'QUESTION_REMOVE_MANY';

/* Fetch actions */
export const fetchQuestionSuccess = (questions: Question[], partial: boolean, lastFetch: number) => ({type: QUESTION_FETCH_SUCCESS, questions, partial, lastFetch});
export const fetchQuestionFailure = (err: any) => {
		console.error('QuestionAction: fetchQuestionFailure', err);
		return {type: QUESTION_FETCH_FAILURE, err};
};
export const fetchOneQuestionQueue = (questionId: string) => ({type: QUESTION_FETCH_ONE_QUEUE, questionId});
export const fetchOneQuestionSuccess = (question: Question) => ({type: QUESTION_FETCH_ONE_SUCCESS, question});
export const fetchOneQuestionFailure = (id: string, err: any) => {
		console.error('QuestionAction: fetchOneQuestionFailure', err);
		return {type: QUESTION_FETCH_ONE_FAILURE, id, err};
};

/* Save actions */
export const saveQuestion = (question: Question) => {
    // console.debug('⮂ QUESTION_SAVE action', question?.id);
    return {type: QUESTION_SAVE, question};
}
export const saveQuestionQueue = (question: Question) => {
    // console.debug('⮂ QUESTION_SAVE_QUEUE action', question?.id);
    return {type: QUESTION_SAVE_QUEUE, question};
}
export const saveQuestionSuccess = (question: Question) => {
    // console.debug('⮂ QUESTION_SAVE_SUCCESS action', question?.id);
    return {type: QUESTION_SAVE_SUCCESS, question};
}
export const saveQuestionFailure = (question: Question, status: number, message: string) => {
    console.warn(`⮂ QUESTION_SAVE_FAILURE error saving question: HTTP ${status}: ${message}`, question?.id);
    return {type: QUESTION_SAVE_FAILURE, question, status, message};
};

/* SaveMany actions */
export const saveManyQuestions = (questions: Question[]) => {
    // console.debug('⮂ QUESTION_SAVE_MANY action', questions?.map(question => question?.id).join(','));
    return {type: QUESTION_SAVE_MANY, questions};
}
export const saveManyQuestionsQueue = (questions: Question[]) => {
    // console.debug('⮂ QUESTION_SAVE_MANY_QUEUE action', questions?.map(question => question.id).join(','));
    return {type: QUESTION_SAVE_MANY_QUEUE, questions};
}

export const saveManyQuestionsSuccess = (questions: Question[]) => {
    // console.debug('⮂ QUESTION_SAVE_MANY_SUCCESS action', questions?.map(question => question.id).join(','));
    return {type: QUESTION_SAVE_MANY_SUCCESS, questions};
}
export const saveManyQuestionsFailure = (questions: Question[], status: number, message: string) => {
		console.warn(`⮂ SAVE_MANY_QUESTIONS_FAILURE Error saving questions: HTTP ${status}: ${message}`, questions?.map(question => question.id).join(','));
		return {type: QUESTION_SAVE_MANY_FAILURE, questions, status, message};
};

/* Remove actions */
export const removeQuestion = (question: Question) => ({ type: QUESTION_REMOVE, question });
export const removeQuestionQueue = (question: Question) => ({ type: QUESTION_REMOVE_QUEUE, question });
export const removeQuestionSuccess = (question: Question) => ({ type: QUESTION_REMOVE_SUCCESS, question });
export const removeQuestionFailure = (question: Question, status: number, message: string) => {
	console.error(`Redux: removeQuestionFailure Error removing question: HTTP ${status}: ${message}`);
	return ({ type: QUESTION_REMOVE_FAILURE, question, status, message });
};

/* Restore actions */
export const restoreQuestion = (question: Question) => ({ type: QUESTION_RESTORE, question });
export const restoreQuestionQueue = (question: Question) => ({ type: QUESTION_RESTORE_QUEUE, question });
export const restoreQuestionSuccess = (question: Question) => ({ type: QUESTION_RESTORE_SUCCESS, question });
export const restoreQuestionFailure = (question: Question, status: number, message: string) => {
	console.error(`Redux: restoreQuestionFailure Error restoring question: HTTP ${status}: ${message}`);
	return ({ type: QUESTION_RESTORE_FAILURE, question, status, message });
};

/* RestoreMany actions */
export const restoreManyQuestions = (questions: Question[]) => ({ type: QUESTION_RESTORE_MANY, questions });

/* RemoveMany actions */
export const removeManyQuestions = (questions: Question[]) => ({ type: QUESTION_REMOVE_MANY, questions });